import { layoutConfig, LayoutConfig } from '@spartacus/storefront'

export const customLayoutConfig: LayoutConfig = {
  ...layoutConfig,
  layoutSlots: {
    ...layoutConfig.layoutSlots,
    ProductDetailsPageTemplate: {
      slots: ['Summary', 'Replacement', 'UpSelling', 'CrossSelling', 'Tabs', 'PlaceholderContentSlot']
    }
  }
}
